import { Injectable } from '@angular/core';
import { SegmentProvider } from '../analytics/segment';
import { AnalyticsEventType, AnalyticsPaymentMethodData, DirectBankVendorType, SegmentLocationNames } from '../../model/types/analytics.const';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { IOrder } from '../../model/models/order/order-interface';
import { LoadingProvider } from '../loading/loading';
import { OrderProvider } from '../order/order';
import { RouteProvider } from '../route/route';
import { getFintoc } from '@fintoc/fintoc-js';
import { TranslateService } from '@ngx-translate/core';
import { FintocStatusType } from '../../model/types/fintoc-status-type';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { APP_CONFIG } from '../../environment';


@Injectable()
export class FintocProvider {
  widget: any;
  widgetEvent: string;
  constructor(
    private routeProvider: RouteProvider,
    private loadingProvider: LoadingProvider,
    private orderProvider: OrderProvider,
    private analytics: SegmentProvider,
    private translate: TranslateService) {
  }
  // this boolean was added to prevent calling the close event after the payment error is triggered
  isPaymentError: boolean = false;

  public async initFintoc(order: IOrder, reviewPrompt: Boolean){

    this.analytics.trackEvent({ eventName: AnalyticsEventType.DirectBankPaymentStarted, analyticsData: {
      senderCountry: order.countryFrom || APP_CONFIG.region.defaultCountryFrom,
      paymentVendor: DirectBankVendorType.Fintoc
    }});
    this.loadingProvider.show();
    try {
       const result = await this.orderProvider.initiateFintoc(order);
       const options = {
        holderType: result.holderType,
        widgetToken: result.widgetToken,
        publicKey:result.publicKey,
        product: result.product,

        onEvent: async (eventName)=>{
          switch(eventName) {
            case FintocStatusType.PaymentError : {
              LoggerProvider.info(this, "Fintoc widget payment error");
              this.analytics.trackEvent({ eventName: AnalyticsEventType.FintocWidgetCompleted, analyticsData: {
                location: SegmentLocationNames.SendMoney,
                product: 'App',
                status: 'Rejected'
                }});
               await this.checkFintocStatus(order, result, reviewPrompt);
               break;
            }
            case FintocStatusType.PaymentCreated : {
              LoggerProvider.info(this, "Fintoc widget payment created");
              this.analytics.trackEvent({ eventName: AnalyticsEventType.FintocWidgetCompleted, analyticsData: {
                location: SegmentLocationNames.SendMoney,
                product: 'App',
                status: 'Approved'
              }});
              await this.checkFintocStatus(order, result, reviewPrompt);
              break;
            }
            case FintocStatusType.Closed: {
              LoggerProvider.info(this, "Fintoc widget has been closed");
              await this.checkFintocStatus(order, result, reviewPrompt);
              break;
            }
         }
        },
        onExit: async () => {
          LoggerProvider.info(this, "Fintoc has been exited prematurely");
          await this.checkFintocStatus(order, result, reviewPrompt);
        }
      };
      const fintoc = await getFintoc();
      if (!fintoc) {
        this.routeProvider.replace(this.routeProvider.pages.SendPayFintocFailed);
        return;
      }
    this.widget = fintoc.create(options);
    this.widget.open();
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Exception during creating fintoc widget');
      this.routeProvider.replace(this.routeProvider.pages.SendPayFintocFailed);
    }
    this.loadingProvider.hide();
  }

  async checkFintocStatus(order, result, reviewPrompt) {
    try {
      const status = await this.orderProvider.getFintocStatus(order, result.id);
      if (status == "Success" || status == "Progress" || status == "Continue") {
        this.loadingProvider.hide();
        this.routeProvider.push(this.routeProvider.pages.SendCompletedPage, { reviewPrompt: reviewPrompt });
      } else {
        this.closeFintocWidget(order);
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Exception during creating fintoc widget');
      this.routeProvider.replace(this.routeProvider.pages.SendPayFintocFailed);
      this.loadingProvider.hide();
    }
  }

  async closeFintocWidget(order) {
    if (this.isPaymentError == false){
      this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
      await this.orderProvider.setFintocOrderCancellation(order);
      this.loadingProvider.hide();
      RmtPopupComponent.showCancel(this.translate.instant('page.trackReviewDetailsPage.paymentStoppedMessage'));
    }
    else
      this.loadingProvider.hide();
    this.isPaymentError = false;
    this.destroyWidget();
  }

  destroyWidget() {
    if(this.widget)
      this.widget.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/providers/fintoc/send-pay-fintoc.ts